import moment from 'moment';

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const formatDateForTable = (date, isUTC = false) => {
  const momentDate = isUTC ? moment(date).utc() : moment(date);

  const formattedDate = momentDate.format('MMM D');
  const formattedTime = momentDate.format('HH:mm:ss');

  return { formattedDate, formattedTime };
};

export const dateTimeFormat = (date, isUTC = false) => {
  if (isUTC) {
    return moment(date).utc().format('HH:mm:ss MMM D');
  }

  return moment(date).format('HH:mm:ss MMM D');
};
